import { RegistrationPageForm } from './form';

export class RegistrationPageFormOutput {
  allowedProjectIds?: string[];
  [keyof: string]: any;

  constructor(form: RegistrationPageForm) {
    Object.entries(form).forEach(([key, value]) => {
      // Important: set undefined values to null to clear them in the backend
      this[key] = value ?? null;
    });
  }

  static ToEditSettingsDto(output: RegistrationPageFormOutput): Record<string, any> {
    return {
      ...Object.fromEntries(Object.entries(output).map(([key, value]) => [key, value === undefined ? null : value]))
    };
  }

  static ToCreateSettingsDto(output: RegistrationPageFormOutput): Record<string, any> {
    return {
      ...Object.fromEntries(Object.entries(output).filter(([key]) => output[key] !== undefined))
    };
  }
}
